/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class VehicleQrCodeDirectiveController {
        public static $inject: string[] = [
            '$window'
        ];

        public vehicle: any;

        constructor(public $window: any) {}

        public printQRCode() : void {
            this.$window.print();
        }
    }

    getDealerwareWebComponentsModule().controller('VehicleQrCodeDirectiveController', VehicleQrCodeDirectiveController);

    export class VehicleQrCodeDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'VehicleQrCodeDirectiveController';
        public controllerAs     : string    =   'vehicleQRCodeController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {vehicle: '='};
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/vehicle/qr_code/vehicle_qr_code_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {
        }

    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareVehicleQrCode",() => new VehicleQrCodeDirective());
}
